import React, {useState, useContext, useEffect} from 'react';
import { ProductContext } from '../../ProductProvider';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { Breadcrumb, Card, Table } from 'react-bootstrap';
import {Helmet} from 'react-helmet-async';
import Preloader from "../../components/Preloader/Preloader";

const config = require('../../config.json');

export default function MyBooks() {
    const { validateLogin, loggedUser, handleImageError, generateDate, generateReturnDate,generateAccessionNo } = useContext(ProductContext);
    const { enqueueSnackbar } = useSnackbar();
    const [bookResult, setBookResult] = useState([]);
    const [loaded, setLoaded] = useState(true);
    const [dispMsg, setDispMsg]=useState('');

    useEffect(()=>{
        if(!loggedUser.isAuthenticated){
          validateLogin();
        }else{
           // handleReset();
            handleBookFetch('NA','All');
        }
      },[loggedUser])

      const handleBookFetch=async()=>{
        //event.preventDefault();
        //console.log("search book : ", searchBook);
        try{
            setLoaded(false);
            setDispMsg('');
            //const { idToken } = (await fetchAuthSession()).tokens ?? {};
            const clientID="VJCollege";
            const searchValue = loggedUser.nickname;
            const searchTopic = "UserID";
            await axios.get(`${config.bookapi.invokeURL}/vjlibrary/issue?fetchKey=${searchValue}&fetchOption=${searchTopic}&clientID=${clientID}`, {
            headers: {
             // Authorization: idToken,
             //'x-api-key':config.api.key
            }
          }).then(async(response) => {
           //console.log("response : ", response.data);
           //setDispMsg(response.data.length+' - Books Found');
           if(response.data.length>0){
            setBookResult(response.data);
           }else{
            setDispMsg("No Books Found!")
           }
            //setFilterResult(response.data);
            enqueueSnackbar(response.data.length+' - Books Found',{variant:'success'}); 
            setLoaded(true);
        }).catch((error)=>{
          //console.log("error:", error);
          enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'}); 
        setLoaded(true);
      })
        }catch(error){
            //console.log("error:", error);
            enqueueSnackbar("Error Occured - " + error.message,{variant : 'warning'});
        }
    }
  
  
  return (
    <div>
        <Helmet>
      <title>My Books - Faculty Portal - VIDYAJYOTI JOURNAL OF THEOLOGICAL REFLECTION</title>
      <meta name="description" content="My Books - Faculty Portal - VIDYAJYOTI JOURNAL OF THEOLOGICAL REFLECTION" />
      <meta name="keywords" content="My Books - Faculty Portal - VIDYAJYOTI JOURNAL OF THEOLOGICAL REFLECTION" /> 
    </Helmet>
    <Preloader show={loaded ? false : true} />
         <div className="d-block mb-4 mb-md-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><i className="fa fa-home" aria-hidden="true"></i></Breadcrumb.Item>
            <Breadcrumb.Item>Library</Breadcrumb.Item>
            <Breadcrumb.Item active>Books</Breadcrumb.Item>
          </Breadcrumb>
          </div>

          <h4>My Books</h4>
      
<Card style={{padding:"0px"}}>
      <Card.Body>
          {bookResult.length>0 ? <Table striped bordered hover>
        <thead >
        <tr className='text-center'>
          <th>#</th>
          <th>Accession No  </th>
          <th>Book Title </th>
          <th>Author  </th>
          <th>Classification No </th>
          <th>Issued To </th>
          <th>Booking Date  </th>
          <th>Return Date </th>
        </tr>
        </thead>
        <tbody>
        {bookResult.map((item,index)=>{return(
          <tr key={index}>
            <td>{index+1}</td>
            <td>{item.accessionNo}</td>
            <td>{item.bookTitle}</td>
            <td>{item.bookAuthor}</td>
            <td>{item.bookClassificationNo}</td>
            <td>{item.bookedfor} <p> ({item.userID})</p></td>
            <td>{item.bookedOn}</td>
            <td>{item.bookedTo}</td>
          </tr>
        )})}
        </tbody>
      </Table>:<h3>{dispMsg}</h3>}
          </Card.Body>
        </Card>
    </div>
  )
}
